import React from "react";
import {Wand2, Mic, Music} from 'lucide-react';

const teamMembers = [
  {
    id: 1,
    name: "Фокусник-Иллюзионист",
    role: "Мастер иллюзий",
    description: "Профессиональный иллюзионист с 10-летним опытом. Удивительные трюки и иллюзии, которые заставят ваших гостей поверить в магию. Работаю с картами, монетами, реквизитом и сценическими иллюзиями.",
    image: "https://static.lumi.new/8a/8a1e99e24d065f7dc73f888171aa5e92.png",
    icon: Wand2,
    skills: ["Карточные трюки", "Сценические иллюзии", "Интерактивная магия"]
  },
  {
    id: 2,
    name: "Ведущий детских праздников",
    role: "Мастер церемоний",
    description: "Харизматичный ведущий с безупречным чувством юмора и умением держать внимание аудитории. Создаю атмосферу праздника, управляю программой и делаю каждое мероприятие незабываемым.",
    image: "https://static.lumi.new/69/69471231bf567dbbf61914bd6bcc9227.jpg",
    icon: Mic,
    skills: ["Проведение церемоний", "Интерактивные игры", "Импровизация"]
  },
  {
    id: 3,
    name: "Диджей и Джаз-бэнд",
    role: "Живая музыка",
    description: "Талантливая певица-мультиинструменталист. Исполняю живую музыку на гитаре, фортепиано и саксофоне. Широкий репертуар от классики до современных хитов создаст идеальную атмосферу.",
    image: "https://static.lumi.new/9c/9c234d4d0ca3e3125dc89a87c866d148.jpg",
    icon: Music,
    skills: ["Гитара, фортепиано, саксофон", "Вокал", "Разнообразный репертуар"]
  }
];

function Reviews() {
  return (
    <section id="reviews" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">Моя Команда</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Профессионалы своего дела, которые сделают ваше мероприятие по-настоящему особенным
          </p>
        </div>

        {/* Team Members Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member) => {
            const IconComponent = member.icon;
            return (
              <div 
                key={member.id} 
                className="bg-gray-900 border border-pink-300/20 rounded-2xl shadow-lg shadow-pink-300/10 overflow-hidden hover:shadow-2xl hover:shadow-pink-300/20 transition-all duration-300 hover:-translate-y-2"
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent"></div>
                  
                  {/* Icon Badge */}
                  <div className="absolute top-4 right-4 bg-pink-300/90 p-3 rounded-full">
                    <IconComponent className="w-6 h-6 text-black" />
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-white mb-2">{member.name}</h3>
                  <p className="text-pink-300 font-medium mb-4">{member.role}</p>
                  
                  <p className="text-gray-300 text-sm leading-relaxed mb-4">
                    {member.description}
                  </p>

                  {/* Skills */}
                  <div className="space-y-2">
                    <p className="text-white font-semibold text-sm">Навыки:</p>
                    <div className="flex flex-wrap gap-2">
                      {member.skills.map((skill, index) => (
                        <span 
                          key={index}
                          className="bg-pink-300/10 text-pink-300 text-xs px-3 py-1 rounded-full border border-pink-300/30"
                        >
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>);

}

export default Reviews;
